import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className="glass-nav sticky top-0 z-40" data-testid="site-navbar">
      <nav className="container-pad mx-auto flex items-center justify-between h-16 md:h-20 max-w-[1400px]">
        <Link to="/" className="flex items-center gap-2" data-testid="navbar-logo">
          <div className="w-9 h-9 rounded-xl bg-[#1E4D3B] grid place-items-center text-[#FDFCFB] font-display font-semibold">F</div>
          <span className="font-display text-xl font-semibold tracking-tight text-[#121C17]">FinSahayak</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {links.map((l) => {
            const active = location.pathname === l.to;
            return (
              <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  active ? "bg-[#F3F1EC] text-[#121C17]" : "text-[#5C6661] hover:text-[#121C17]"
                }`}>
                {l.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link to="/login" data-testid="navbar-admin-login" className="text-sm text-[#5C6661] hover:text-[#121C17]">
            Login
          </Link>
          <Link to="/services" data-testid="navbar-cta-get-started"
            className="btn-primary rounded-full px-5 py-2.5 text-sm font-medium">
            Get Started
          </Link>
        </div>

        <button onClick={() => setOpen(!open)} className="md:hidden p-2" data-testid="navbar-mobile-toggle" aria-label="Toggle menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-[#E5E2DC] bg-white" data-testid="navbar-mobile-panel">
          <div className="container-pad py-4 flex flex-col gap-1">
            {links.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`nav-mobile-${l.label.toLowerCase()}`}
                className="py-3 text-[#121C17] font-medium border-b border-[#F3F1EC]">{l.label}</Link>
            ))}
            <Link to="/login" data-testid="nav-mobile-admin"
              className="py-3 text-[#5C6661]">Login</Link>
            <Link to="/services" data-testid="nav-mobile-cta"
              className="btn-primary rounded-full px-5 py-3 text-center font-medium mt-3">Get Started</Link>
          </div>
        </div>
      )}
    </header>
  );
};
